import Bank from '../model/bank'
import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export function fetchBanks(): Promise<RequestResponse<Bank[]>> {
  return secureRequest('GET', url('/v2/banks', { country: 'DK' }))
}
